(function() {
	'use strict';

	angular.module('reportApp')
			.controller('ReportController', ReportController);

	ReportController.$inject = [ '$scope', 'CONST_REPORT', 'ReportService',
			'CommonService', '$window', '$filter', '$http' ];

	function ReportController($scope, CONST_REPORT, ReportService,
			CommonService, $window, $filter, $http) {

		var currentDate = new Date();
		currentDate.setHours(0,0,0,0)
		var tDate = new Date("04/23/2024")
		if(tDate <= currentDate
			&& document.getElementById("fileTemplateHotlink") != null
			&& document.getElementById("fileTemplateHotlink") != undefined)
		{
			document.getElementById("fileTemplateHotlink").style.display = "none";
		}

		var reportCtr = this;
		reportCtr.report = {};
		var self = $scope;
		self.CONST_REPORT = CONST_REPORT;
		reportCtr.report.templateSeq = CONST_REPORT.TEMPLATE_SEQ[0].code;
		reportCtr.report.netoffDetail = CONST_REPORT.NETOFF_DETAIL[0].code;
		reportCtr.report.formatExport = CONST_REPORT.FORMAT_EXPORT[0].code;
		reportCtr.report.month = CONST_REPORT.MONTHS[0].code;
		reportCtr.report.fromMonth = CONST_REPORT.MONTHS[0].code;
		reportCtr.report.toMonth = CONST_REPORT.MONTHS[11].code;
		reportCtr.report.year = $filter('date')(new Date(),'yyyy');
		reportCtr.processResults = CONST_REPORT.PROCESS_RESULTS[0].code;
		//reportCtr.systemDate = $filter('date')(new Date(), "MM");
		/*if(reportCtr.systemDate == null || reportCtr.systemDate != undefined){
			reportCtr.systemDate= '01';
		}*/
		reportCtr.report.fromMonthYear = reportCtr.report.fromMonth + '' + reportCtr.report.year;
		reportCtr.report.toMonthYear = reportCtr.report.toMonth + '' + reportCtr.report.year;
		reportCtr.report.reportTime = "";
		reportCtr.report.transactionType = '';
		reportCtr.datePickerOpenStatus = {};
		reportCtr.datePickerOpenStatus.fromDate = false;
		reportCtr.datePickerOpenStatus.toDate = false;
		reportCtr.report.fromDate = new Date();
		reportCtr.report.toDate = new Date();
		reportCtr.enableOffice = true;
		reportCtr.openCalendar = function(date) {
			$scope.clearMessage();
			reportCtr.datePickerOpenStatus[date] = true;
			reportCtr.validateDates();
		}
		reportCtr.offices = CommonService.query({
			masterurl : 'get-all-office'
		});
		reportCtr.officeVoucher = CommonService.query({
			masterurl : 'get-all-office',flgSort:true
		});
		reportCtr.pics = CommonService.query({
			masterurl : 'get-pics'
		});
		reportCtr.returnLetterCitys = CommonService.query({masterurl:'get-return-letter-city'});
		/**
		 * Report NetOff Summary <property name="bi.ws.netoff.summary.url"
		 * value="/ga-great/NetoffSummary/NetoffSummary.xdo"/>
		 */
		reportCtr.doPrintReportNetOffSummary = function() {
			ReportService.download({
				uri : 'report-netoff-summary'
			}, reportCtr.report);
		};
		/**
		 * Report Paid Payment <property name="bi.ws.paid.payment.url"
		 * value="/ga-great/PaidPaymentReport/PaidPaymentReport.xdo"/>
		 */
		reportCtr.doPrintReportPaidPayment = function() {
			ReportService.download({
				uri : 'report-paid-payment'
			}, reportCtr.report);
		};
		/**
		 * Report Contest Payment Detail 1 Report Contest Payment Detail 2
		 * <property name="bi.ws.contest.payment.detail.url"
		 * value="/ga-great/ContestPaymentDetails/ContestPaymentDetails.xdo"/>
		 */
		reportCtr.doPrintReportContestPaymentDetail = function() {
			ReportService.download({
				uri : 'report-contest-payment-detail'
			}, reportCtr.report);
		};
		/**
		 * Report Contest Payment Summary <property
		 * name="bi.ws.contest.payment.summary.url"
		 * value="/ga-great/ContestPaymentSummary/ContestPaymentSummary.xdo"/>
		 */
		reportCtr.doPrintReportContestPaymentSummary = function() {
			ReportService.download({
				uri : 'report-contest-payment-summary'
			}, reportCtr.report);
		};
		/**
		 * Report Tax Invoice Detail <property
		 * name="bi.ws.tax.invoice.detail.url"
		 * value="/ga-great/TaxInvoiceDetail/TaxInvoiceDetail.xdo"/>
		 */
		reportCtr.doPrintReportTaxInvoiceDetail = function() {
			ReportService.download({
				uri : 'report-tax-invoice-detail'
			}, reportCtr.report);
		};
		/**
		 * Report Tax Invoice Cancel Detail <property
		 * name="bi.ws.tax.invoice.cancel.detail.url"
		 * value="/ga-great/TaxInvoiceCancelDetail/TaxInvoiceCancelDetail.xdo"/>
		 */
		reportCtr.doPrintReportTaxInvoiceCancelDetail = function() {
			ReportService.download({
				uri : 'report-tax-invoice-cancel-detail'
			}, reportCtr.report);
		};
		/**
		 * Report Tax Invoice Summary <property
		 * name="bi.ws.tax.invoice.summary.url"
		 * value="/ga-great/TaxInvoiceSummary/TaxInvoiceSummary.xdo"/>
		 */
		reportCtr.doPrintReportTaxInvoiceSummary = function() {
			ReportService.download({
				uri : 'report-tax-invoice-summary'
			}, reportCtr.report);
		};
		/**
		 * Report Transaction Detail <property
		 * name="bi.ws.transaction.detail.url"
		 * value="/ga-great/TransactionDetail/TransactionDetail.xdo"/>
		 */
		reportCtr.doPrintReportTransactionDetail = function() {
			ReportService.download({
				uri : 'report-transaction-detail'
			}, reportCtr.report);
		};
		/**
		 * Report Invalid Id <property name="bi.ws.report.invalid.id.url"
		 * value="/ga-great/InvalidID/InvalidID.xdo"/>
		 */
		reportCtr.doPrintReportInvalidId = function() {
			ReportService.download({
				uri : 'report-invalid-id'
			}, reportCtr.report);
		};
		/**
		 * Report FATCA <property name="bi.ws.report.fatca.url"
		 * value="/ga-great/FATCAReport/FATCAReport.xdo"/>
		 */
		reportCtr.doPrintReportFATCA = function() {
			ReportService.download({
				uri : 'report-fatca'
			}, reportCtr.report);
		};
		/**
		 * Report DAY END COLLECTION <property
		 * name="bi.ws.report.day.end.collection.url"
		 * value="/ga-great/DayEndCollection/DayEndCollection.xdo"/>
		 */
		reportCtr.doPrintReportDayEndCollection = function() {
			ReportService.download({
				uri : 'report-day-end-collection'
			}, reportCtr.report);
		};
		/**
		 * Report NETOFF_DETAIL bi.ws.netoff.detail.n.url:
		 * /ga-great/NetoffDetailN/NetoffDetailN.xdo bi.ws.netoff.detail.a.url:
		 * /ga-great/NetoffDetailA/NetoffDetailA.xdo bi.ws.netoff.detail.r.url:
		 * /ga-great/NetoffDetailR/NetoffDetailR.xdo bi.ws.netoff.detail.w.url:
		 * /ga-great/NetoffDetailW/NetoffDetailW.xdo
		 */
		reportCtr.doPrintReportNetoffDetail = function() {
			ReportService.download({
				uri : 'report-netoff-detail'
			}, reportCtr.report);
		};
		/**
		 * Report Payment checking valid Report Payment checking valid log
		 * Report Payment checking valid summary
		 */
		reportCtr.doPrintReportPaymentCheckingValid = function() {
			ReportService.download({
				uri : 'report-payment-checking-valid'
			}, reportCtr.report);
		};
		reportCtr.doPrintReportPaymentCheckingValidLog = function() {
			ReportService.download({
				uri : 'report-payment-checking-valid-log'
			}, reportCtr.report);
		};
		reportCtr.doPrintReportPaymentCheckingValidSummary = function() {
			ReportService.download({
				uri : 'report-payment-checking-valid-summary'
			}, reportCtr.report);
		};
		reportCtr.officeDto = function(item) {
			if (reportCtr.report.officeCode == null
					|| reportCtr.report.officeCode == undefined
					|| reportCtr.report.officeCode == '') {
				reportCtr.enableOffice = true;
			} else {
				reportCtr.enableOffice = false;
				reportCtr.officeBranchCode = item.officeBranchCode;
				reportCtr.officeCode = item.officeCode;
				// reportCtr.officeResult
				// =CommonService.get({masterurl:'get-office-by-officeCode',officeCode:reportCtr.report.officeCode});
			}

		};
		reportCtr.validateDates = function() {
			$scope.clearMessage();

			var currentDate = new Date();
			var toDate = moment($scope.reportCtr.report.toDate, "DD/MM/YYYY");
			var fromDate = moment($scope.reportCtr.report.fromDate,
					"DD/MM/YYYY");
			if (currentDate < toDate) {
				reportCtr.checkDate = true;
				$scope
						.addAlert(
								'Vui lòng chọn Đến Ngày bằng hoặc nhỏ hơn ngày hiện tại.',
								'error');
			} else if (currentDate < fromDate) {
				reportCtr.checkDate = true;
				$scope
						.addAlert(
								'Vui lòng chọn Từ Ngày bằng hoặc nhỏ hơn ngày hiện tại.',
								'error');
			} else if (toDate.diff(fromDate) < 0) {
				reportCtr.checkDate = true;
				$scope.addAlert(
						'Vui lòng chọn Đến Ngày lớn hơn hoặc bằng Từ ngày.',
						'error');
			} else {
				reportCtr.checkDate = false;
			}
		};
		reportCtr.dateOptions = {
			maxDate : new Date()
		};

		/**
		 * Report Transaction investment detail <property
		 * name="bi.ws.transaction.investment.detail.url"
		 * value="/ga-great/TransactionInvesmentDetai/TransactionInvesmentDetai"/>
		 */
		reportCtr.doPrintReportInvestmentDetail = function() {
			ReportService.download({
				uri : 'report-investment-detail'
			}, reportCtr.report);
		};

		/**
		 * Report collection at home <property
		 * name="bi.ws.collection.at.home.url"
		 * value="/ga-great/CollectionAtHomeReport/CollectionAtHomeReport.xdo"/>
		 */
		reportCtr.doPrintReportCollectionAtHome = function() {
			ReportService.download({
				uri : 'report-collection-at-home'
			}, reportCtr.report);
		};
		
		/**
		 * Report transaction payment request
		 * Link: /ga-great/TransactionPaymentRequest/TransactionPaymentRequest.xdo
		 */
		reportCtr.doPrintReportTransactionPaymentRequest = function() {
			ReportService.download({
				uri : 'report-transaction-payment-request'
			}, reportCtr.report);
		};

		reportCtr.getAgent = function() {
			if (reportCtr.report.officeCode === null) {
				reportCtr.agentList = null;
			} else {
				ReportService.query({
					uri : 'getAgentOffice',
					officeCode : reportCtr.report.officeCode
				}, function(result) {
					reportCtr.agentList = result;
				});
			}
		};
		
		/**
		 * Report return letter details
		 * Link: /ga-great/ReturnLetterDetails/ReturnLetterDetails.xdo
		 */
		reportCtr.doPrintReportReturnLetterDetails = function() {
			ReportService.download({
				uri : 'report-return-letter-details'
			}, reportCtr.report);
		};
		
		/**
		 * Report return letter summary
		 * Link: /ga-great/ReturnLetterSummary/ReturnLetterSummary.xdo
		 */
		reportCtr.doPrintReportReturnLetterSummary = function() {
			ReportService.download({
				uri : 'report-return-letter-summary'
			}, reportCtr.report);
		};
		
		reportCtr.getMonthYear = function() {
			if(reportCtr.report.year != null && reportCtr.report.year != undefined) {
				if(reportCtr.report.fromMonth != null && reportCtr.report.fromMonth != undefined) {
					reportCtr.report.fromMonthYear = reportCtr.report.fromMonth + '' + reportCtr.report.year;
				}
				if(reportCtr.report.toMonth != null && reportCtr.report.toMonth != undefined) {
					reportCtr.report.toMonthYear = reportCtr.report.toMonth + '' + reportCtr.report.year;
				}
			}
			
		};
		
		/**
		 * Report agent info
		 * Link: /ga-great/ReportAgentInfo/ReportAgentInfo.xdo
		 */
		reportCtr.doPrintReportAgentInfo = function() {
			ReportService.download({
				uri : 'report-agent-info'
			}, reportCtr.report);
		};
		
		reportCtr.doPrintAdvancePaymentPayOff = function() {
			ReportService.download({
				uri : 'report-advance_payment_pay_off'
			}, reportCtr.report);
		};
		
		reportCtr.doPrintSubmitRefund = function() {
			ReportService.download({
				uri : 'report-submit-refund'
			}, reportCtr.report);
		};
	}
})();
